import { useState } from 'react';
import BrandMark from '../BrandMark';
import { colors } from '../theme';

const NAV_LINKS = [
  { label: 'How it Works', href: '/#how' },
  { label: 'Technology', href: '/technology' },
  { label: 'Industries', href: '/industries' },
  { label: 'Team', href: '/team' },
];

const Nav = ({ onOpenContact }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleGetInTouch = () => {
    onOpenContact('contact');
    setMobileMenuOpen(false);
  };

  return (
    <nav style={{ position: 'sticky', top: 0, zIndex: 50, background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(16px)', borderBottom: `1px solid ${colors.border}`, padding: '0 clamp(20px, 5vw, 48px)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
      <div style={{ maxWidth: 1080, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 11, minWidth: 0 }}>
          <BrandMark size={34} />
          <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: '0.05em', lineHeight: 1.1, color: colors.navy, whiteSpace: 'nowrap' }}>NTHRA LABS</div>
          <div className="nav-meta" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

          </div>
        </a>

        {/* Desktop Menu */}
        <div className="desktop-menu" style={{ alignItems: 'center', gap: 24 }}>
          {NAV_LINKS.map(link => (
            <a key={link.href} href={link.href} className="navlink" style={{ color: colors.navy, fontSize: 13.5, fontWeight: 500 }}>
              {link.label}
            </a>
          ))}
          <a href="https://blog.nthralabs.com" target="_blank" rel="noopener noreferrer" className="navlink" style={{ color: colors.navy, fontSize: 13.5, fontWeight: 500 }}>
            Blog
          </a>
          <button onClick={handleGetInTouch} className="cta" aria-label="Get in touch"
            style={{ background: `linear-gradient(135deg,${colors.teal},${colors.tealDark})`, border: 'none', borderRadius: 8, padding: '9px 22px', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', letterSpacing: '0.04em', transition: 'all 0.2s' }}>
            Get in touch
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="mobile-menu" aria-label="Toggle mobile menu" aria-expanded={mobileMenuOpen}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, color: colors.navy }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {mobileMenuOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div style={{ position: 'absolute', top: 64, left: 0, right: 0, background: '#ffffff', borderBottom: `1px solid ${colors.border}`, padding: '16px 20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV_LINKS.map(link => (
            <a key={link.href} href={link.href} onClick={() => setMobileMenuOpen(false)}
              style={{ color: colors.navy, fontSize: 15, fontWeight: 500, padding: '12px 4px', borderBottom: `1px solid ${colors.borderLight}` }}>
              {link.label}
            </a>
          ))}
          <a href="https://blog.nthralabs.com" target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)}
            style={{ color: colors.navy, fontSize: 15, fontWeight: 500, padding: '12px 4px', borderBottom: `1px solid ${colors.borderLight}` }}>
            Blog
          </a>
          <button onClick={handleGetInTouch} className="cta" aria-label="Get in touch"
            style={{ width: '100%', background: `linear-gradient(135deg,${colors.teal},${colors.tealDark})`, border: 'none', borderRadius: 8, padding: '12px', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginTop: 12 }}>
            Get in touch
          </button>
        </div>
      )}
    </nav>
  );
};

export default Nav;
